import { api } from "../index";
import { CUSTOM_PLAN } from "../../constants/landingPage";

export const subscriptionPlansApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionPlans: builder.query({
      query: ({locale = "ar"}) => `/api/v1/public/subscription_plans?locale=${locale}`,
      transformResponse: (response) => {
        const plans = response?.data || [];
        
        // Sort logic: custom plan first, then others
        const enterprisePlan = plans.find((plan) => plan?.plan_type === CUSTOM_PLAN);
        const otherPlans = plans.filter((plan) => plan?.plan_type !== CUSTOM_PLAN);
        const orderedPlans = enterprisePlan ? [enterprisePlan, ...otherPlans] : otherPlans;
        
        return { ...response, data: orderedPlans };
      },
    }),
  }),
});

export const { useGetSubscriptionPlansQuery } = subscriptionPlansApi;
